module.exports = ".routeContainer {\n  display: block; }\n\n.routeContainer > *:not(router-outlet) {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main